<template>
	<div ref="notice" v-parallax-fit="parallax" class="notice">
		<img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/17_FinalNotice@2x.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mutationObserver: null,
				parallax: [
					{
						start: 20000,
						end: 24000,
						fromStyle: { transform: 'translateY(-500%) rotate(0deg)' },
           				toStyle: { transform: 'translateY(0%) rotate(0deg)' },
						easing: 'linear'
					},
					{
						start: 26000,
						end: 30000,
						fromStyle: { transform: 'translateY(0%) rotate(0deg)' },
           				toStyle: { transform: 'translateY(500%) rotate(50deg)' },
						easing: 'linear'
					}
				]
			}
		},
		mounted() {
			const evidence = {
			    items: [
			        {
			        	image: '/themes/rise-theme/dist/images/estate/character-view/ozzie/evidence/4.png',
			          	url: 'https://www.usatoday.com/story/money/2022/11/20/zombie-debt-foreclosure-mortgages-explained/10726148002/',
			          	link_title: {
							'en': "What is ‘Zombie Debt?' Why homeowners are facing foreclosure on old mortgages",
							'es': '¿Qué es la \'deuda zombie\'? ¿Por qué los propietarios se enfrentan a la ejecución hipotecaria de hipotecas antiguas?'
						},
			        }
			    ],
			    text: {
					'en': "They’ve been holding them, having no communication with the borrowers...and then all of a sudden, they’re coming out of the woodwork and are threatening to foreclose because now there is value in the property. They can foreclose on the property and actually get something after the first mortgages are paid off.",
					'es': 'Los han estado reteniendo, sin tener comunicación con los prestatarios... y luego, de repente, salen de la nada y amenazan con ejecutar la hipoteca porque ahora hay valor en la propiedad. Pueden ejecutar la hipoteca de la propiedad y obtener algo después de que se paguen las primeras hipotecas.'
				}
		    };

		    const text = {
				'en': "Oswaldo was up to date on property taxes, but because his brother had taken out a second mortgage, there were still payments owned on the house. More and more homeowners have been notified of old debt that they assumed was paid off, dubbed \"zombie debt.\"",
				'es': 'Oswaldo estaba al día con los impuestos sobre la propiedad, pero debido a que su hermano había tomado una segunda hipoteca, todavía había pagos de propiedad sobre la casa. Cada vez más propietarios han sido notificados de deudas antiguas que asumieron que se pagaron, denominadas "deudas zombis".'
			};

			this.mutationObserver = new window.MutationObserver(mutationList => {
			   	mutationList.forEach( mutation => {
			        if (mutation.target.style.transform == 'translateY(0%) rotate(0deg)') {
			        	this.$evidence.value = JSON.stringify(evidence);
		    			this.$readMore.value = text;
			        }
			    });
		    });

		    this.mutationObserver.observe(this.$refs.notice, {
		    	attributes: true,
		    	attributeFilter: ['style']
		    });
		},
		unmounted() {
		    this.mutationObserver.disconnect();
		}
	}
</script>

<style lang="scss" scoped>
	.notice {
		position: absolute;
	    left: 100%;
	    top: 0;
	    transition: all 0.5s linear;
	    width: 500px;
	    margin-left: -180px;
	    margin-top: 75px;
	}

	@media screen and (max-width: 1600px) {
		.notice {width: 450px;}
	}

	@media screen and (max-width: 991px) {
		.notice {width: 400px;}
	}

	@media screen and (max-width: 650px) {
		.notice {
			width: 270px;
			margin-top: 10px;
		}
	}
</style>
